import { el, setChildren, type RedomComponent } from "redom";
import { fillInUserListModal } from "../components/record-content.js"
import { Modal } from "bootstrap"
import { setSignInModal } from "../components/build-modal.js";
import type { UserPage } from "#/types";
import { FollowService, FollowType } from "../services/follow-service.js";

export class RecordPageFollowManager implements RedomComponent {
    followBtn = el("button.btn.btn-sm.clickable#followBtn", { type: "button" })
    el: HTMLElement = el(".col-auto noPadding", { style: "width: 26%; float: right; height: 2.5rem;" }, this.followBtn)

    constructor(protected followingId: string, protected isFollowed: boolean, meIsDefined: boolean) {
        if (meIsDefined) this.followBtn.onclick = this.toggle.bind(this)
        else setSignInModal(this.followBtn, "Follow this user?", "to follow!")
        this.renderFollowIcon()
    }

    protected renderFollowIcon() {
        this.followBtn.classList.toggle("followBtn-following", this.isFollowed);
        this.followBtn.textContent = this.isFollowed ? "following" : "follow";
    }
    toggle(){
        this.isFollowed = !this.isFollowed
        const action = this.isFollowed ? FollowService.follow : FollowService.unfollow;
        action(this.followingId);
        this.renderFollowIcon()
    }
}

export class UserPageFollowManager extends RecordPageFollowManager {
    private followerCount: number = 0;
    private followingCount: number = 0;
    private followerCountEl = el("span.follow-text#followersContent", { align: "center" })
    private followingCountEl = el("span.follow-text#followingsContent", { align: "center" })
    override el = el(".follow-container row", this.followerCountEl, this.followingCountEl)
    constructor(userPage: UserPage, meIsDefined: boolean, myPage: boolean) {
        const { uploader, amIFollowed } = userPage
        super(uploader.id, amIFollowed, meIsDefined)
        if (!myPage) {
            const followEl = el("", {style: "height: 100%", align: "center" }, this.followBtn)
            this.el.appendChild(followEl)
        }

        this.followerCount = uploader.followersCount;
        this.followingCount = uploader.followingsCount;
        this.renderCount(FollowType.Follower);
        this.renderCount(FollowType.Following);
    }

    private renderCount(type: FollowType) {
        const count = type === FollowType.Follower ? this.followerCount : this.followingCount;
        const countEl = type === FollowType.Follower ? this.followerCountEl : this.followingCountEl;
        const clickable = count > 0 ? { className: "clickable", onclick: () => this.showList(type) } : {};
        const content = el("div", clickable,
            el("span", { textContent: count.toString() }),
            el("p", { textContent: `${type}s` })
        );
        setChildren(countEl, content);
    }

    override toggle() {
        if (this.isFollowed) this.followerCount--
        else this.followerCount++
        this.renderCount(FollowType.Follower);
        this.renderCount(FollowType.Following);
        super.toggle()
    }

    private async showList(type: FollowType) {
        const modalID = '#' + type + 'sModal'
        const modal = Modal.getOrCreateInstance(modalID);
        modal.show();
        try {
            const result = await (type === FollowType.Follower
                ? FollowService.getFollowers(this.followingId)
                : FollowService.getFollowings(this.followingId));
            if (result) fillInUserListModal(result.users, this.capitalize(type), modal);
        } catch {
            alert(`Could not load ${type}s`);
        }

    }

    private capitalize(str: string) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }
}

